import { useRef, useState, useEffect } from 'react';
import useAuth from '../../hooks/useAuth';
import 
loginImg from '../../assets/images/login-img.png'
import { Link, useNavigate, useLocation, NavLink } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BsXCircle, BsEyeSlash, BsEye } from "react-icons/bs";
import workWiseLogo from '../../assets/images/workwise-logo-white.png';
import axios from '../../api/axios';

const LOGIN_URL = '/';

const Login = () => {
    const { setAuth } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/home";
    const userRef = useRef();
    const [user, setUser] = useState('');
    const [pwd, setPwd] = useState('');
    const [errMsg, setErrMsg] = useState({
        er_username : '',
        er_password : '' 
    });
    const [remeberMeStatus, setRemeberMeStatus] = useState(false);
    const [passwordStatus, setPasswordStatus] = useState("password");
    // --------------------------------------------------------------- Login Handle ------------------------------------
    const handleSubmit = async(e) => {
        e.preventDefault();
        try {
            if (user === '' || user === null) {
                setErrMsg({...errMsg, er_username:"System Id is required!"})
            }
            else if (pwd === '' || pwd === null) {
                setErrMsg({...errMsg, er_password:"Password is required!"})
            }
            else {
              const response = await axios.post(LOGIN_URL, {
                    username: user,
                    password: pwd
                })
                const accessToken = response?.data?.accessToken;
                    const userRoles = response?.data?.roles;
                    localStorage.setItem('user', btoa(user));
                    localStorage.setItem('user_id', btoa(response?.data?.results?.[0]?.user_id));
                    localStorage.setItem('roles', btoa(JSON.stringify(userRoles)));
                    localStorage.setItem('hitting', '****');
                    setAuth({ user, pwd, "roles": userRoles, accessToken });
                    if (remeberMeStatus) {
                        localStorage.setItem('remeberMeUser', btoa(user));
                        localStorage.setItem('remeberMePassword', btoa(pwd));
                    }
                    else {
                        localStorage.removeItem('remeberMeUser')
                        localStorage.removeItem('remeberMePassword')
                    }
                    setUser('');
                    setPwd('');
                    navigate(from, { replace: true });
                    window.location.reload(false);
            }
        } catch (err) {
            if (!err?.response) {
                toast.error("No Server Response!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            } else if (err.response?.status === 400) {
                toast.error("Missing Username or Password!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            } else if (err.response?.status === 401) {
                setErrMsg({...errMsg, er_username:"Invalid System Id!"})
            } else if (err.response?.status === 404) {
                setErrMsg({...errMsg, er_password:"Invalid Password!"})
            } else {
                toast.error("Login Failed!", {
                    position: toast.POSITION.TOP_RIGHT,
                    theme: "colored",
                    autoClose: 2000
                });
            }
        }
    }
    // --------------------------------------------------------- Remeber Me Setup --------------------------------
    const RemeberMeSet = () => event => {
        event.target.checked ? setRemeberMeStatus(true) : setRemeberMeStatus(false)
    }
    // -------------------------------------------------------------- Use Effect ------------------------------------
    useEffect(() => {
        setErrMsg({
            er_username : '',
            er_password : '' 
        });
        setUser(localStorage.getItem('remeberMeUser')&&atob(localStorage.getItem('remeberMeUser')) || '');
        setPwd( localStorage.getItem('remeberMePassword')&&atob(localStorage.getItem('remeberMePassword')) || '')
        if (localStorage.getItem('remeberMeUser')) {
            setRemeberMeStatus(true);
        }
        userRef.current.focus();
        localStorage.removeItem("user")
        localStorage.removeItem("roles")
        localStorage.removeItem("user_id")
        localStorage.removeItem("rolexModuleData")
        localStorage.removeItem("serialSequence")
        localStorage.removeItem("userProfile")
    }, [])
    
    return (
            <div className="Almuni">
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div className="login-img">
                                <div className="loginvedio">
                                    {/* <video playsInline="playsInline" autoPlay="autoplay" muted="muted" loop="loop">
                                        <source src={loginVideo} type="video/mp4" />
                                    </video> */}
                                    <img src={loginImg} alt="Login Images" />
                                </div>
                                {/* <img src="./images/alum.png"/> */}
                                <div className="mask" >
                                    <div className="mask-in">
                                        {/* <p>ProjectWise</p> */}
                                        <img src={workWiseLogo} alt="ProjectWise Management Software" />
                                        <h1>Project Management Software</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-6">
                            <div className="login-page ">
                                    <div className="login-field">
                                        <h1>Sign in</h1>
                                        {/* <p>Please fill your details to access your account</p> */}
                                        <p>Don't have an account?  <Link to="/register">Sign up</Link></p>
                                        <form onSubmit={handleSubmit} className="loginForm">
                                            <div className="userField">
                                                <label>System ID</label>
                                                <div className="input-icon">
                                                    <NavLink className="icon" onClick={() => setUser('')}>{user ? <BsXCircle />: ''}</NavLink>
                                                    <input className="myInput" type="text" id="user_id" ref={userRef} autoComplete="off" onChange={(e) => (setUser(e.target.value),setErrMsg({...errMsg,er_username : ''}))} value={user} placeholder="Enter Your System ID" />
                                                </div>
                                                {errMsg?.er_username && <div className="errMsg">{errMsg?.er_username}</div>}
                                            </div>
                                            <div className="userField">
                                                <label >Password</label>
                                                <div className="input-icon">
                                                    {passwordStatus === "password" ? < NavLink className="icon" onClick={() => setPasswordStatus("text")} ><BsEyeSlash /></NavLink> :
                                                        <NavLink className="icon" onClick={() => setPasswordStatus("password")} ><BsEye /></NavLink>}
                                                    <input id="password" onChange={(e) => (setPwd(e.target.value),setErrMsg({...errMsg,er_password : ''}))} value={pwd} className="myInput" type={passwordStatus} placeholder="Enter Your Password" />
                                                    {/* <HoverTooltip arrow title="Password must be of 8 to 24 characters - 1 uppercase, 1 lowercase, 1 number and a special character!">
                                                        <span className="passInfo"><FaInfoCircle /></span>
                                                    </HoverTooltip> */}
                                                </div>
                                                {errMsg?.er_password && <div className="errMsg">{errMsg?.er_password}</div>}
                                            </div>
                                        
                                            <div className="remember-me">
                                                <div className='row'>
                                                    <div className='col-md-6'>
                                                        <label htmlFor="remember-me">
                                                            <input type="checkbox" className="checkbox" id="remember-me" checked={remeberMeStatus} onChange={RemeberMeSet()} />Remember me
                                                        </label>
                                                    </div>
                                                    <div className='col-md-6'>
                                                        <Link to='/forgetpassword' align="center" className="forgot">Forgot Password?</Link>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="clearfix"></div>
                                            <button type='submit' className="login-btn1 ">Sign in</button>
                                            {/* <strong>Don't have an account?  <Link to="/register">Sign up</Link></strong> */}
                                        </form>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default Login